<template>
<main>
	<div style="max-width:1200px;margin:0 auto;">
    <div v-if="!urlInvalid">
      <div v-if="creatingEvent" class="card shadow p-4 mt-4 text-center" style="min-height: 601px;">
          <div class="row mt-3">
            <div class="col-12">
              <h4 class="text-secondary">{{$t('lang.calendar.waitplease')}}...</h4>
              <img src="@/assets/images/creatingevent.gif"/>
            </div>
          </div>
      </div>
      <div v-if="newevent && !creatingEvent" class="card shadow p-4 mt-4 text-center" style="min-height: 601px;">
          <div class="w-100" v-if="avatar">
          <img class="rounded-circle border-color img-user mb-3" width="80px" :src="avatar" />
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <h4>{{$t('lang.calendar.confirmed',{name: name})}}</h4>
            </div>
          </div>

          <div class="row mt-3" >
            <div class="col-12">
              <span>{{$t('lang.calendar.thanks', {firstname: newevent.first_name, email: newevent.email})}}</span>
            </div>
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <strong class="text-secondary mt-2"><i class="icon-calendar mr-2"></i>{{dayselected[0]}}/{{dayselected[1]}}/{{dayselected[2]}} {{dayselected[3]}}hs.</strong>
            </div>
          </div>
          <div class="row mt-3" >
            <div class="col-12">
              <strong class="text-secondary mt-2"><i class="icon-globe mr-2"></i>
                {{calendar.timezonelabel}}</strong>
            </div>
          </div>
      </div>
      <loadingSpinnerBar v-if="loadingfirst"/>
      <div v-if="!newevent && !creatingEvent" class="card shadow p-4 mt-4">
        <div class="row mt-4" :class="(loadingfirst) ? 'blur':''">

				<div class="col-lg-4" >
					<div class="row mb-2">
						<div class="col-12" v-if="openform">
							<button @click="back()" class="btn btn-primary float-left"><i class="icon-arrow-left mr-2"></i>{{ $t('lang.button.back') }}</button>
						</div>
					</div>
						<div class="w-100" v-if="avatar">
						<img class="rounded-circle border-color img-user mb-3" width="80px" :src="avatar" />
						</div>
						<strong class="text-secondary">{{name}}</strong>
						<h3>{{calendar.title}}</h3>
						<strong class="text-secondary mt-2"><i class="icon-clock mr-2"></i>{{calendar.duration}}</strong>
						<p v-if="calendar.calendar_description" class="mt-3">{{calendar.calendar_description}}</p>
				</div>
				<div class="col-lg-8 border-left pb-4 mb-4" >

              <h5 class="" v-if="!daylabel">{{$t('lang.calendar.selectmonth',{'name':calendar.name})}}</h5>
              <h5 class="" v-if="daylabel && dayselected.length == 0">{{$t('lang.calendar.selectday',{'name':calendar.name,'day':daylabel,'month':$t('lang.label.' + monthlabel )})}}</h5>
              <h5 class="" v-if="daylabel && dayselected.length > 0">{{$t('lang.calendar.selecthour',{'name':calendar.name,'day':daylabel,'month':$t('lang.label.' + monthlabel ),'timezone':calendar.timezonelabel,'hour':dayselected[3]})}}</h5>
              <div class="text-secondary pt-2 " v-if="dayselected.length == 0">
              <i class="icon-arrow-left cursor-pointer
              rounded-circle bg-primary text-white p-2 mr-2"
              @click="nextMonth(currentmonth-1)"
              v-if="!loading && fixedyear < theyear || (fixedyear == theyear && fixedmonth < currentmonth )"></i>
              <span>{{$t('lang.label.' + monthlabel )}} {{theyear}}</span>
              <i v-if="!loading" class="cursor-pointer icon-arrow-right ml-2
              rounded-circle text-white bg-primary p-2"
              @click="nextMonth(currentmonth+1)"></i>
              <span class="loadingres spinner-border loading-spinner ml-2" v-if="loading"></span>
              </div>
              <Calendar
                @createEvent="createEvent($event)"
                :class="loading ? 'blur':''"
                @open="openForm"
                @showday="showDay($event)"
                @timezone="selectTimeZone($event)"
                :timezones="timezones"
                @eventcreated="eventCreated($event)"
                @nextMonth="nextMonth(currentmonth+1)"
                :key="calkey"
                :calendar="calendar"
                :monthlabel="monthlabel" />

          </div>
        </div>
      </div>
    </div>
    <div v-else class="d-flex flex-rowcard shadow p-3 m-4 text-center ">
        <div>
        <span><i class="icon-window-close-o text-danger mr-2" style="font-size: 1.5em;"></i></span>
        </div>
        <div>
          <p>{{ $t('lang.label.calendar_not_valid')}}
        </p>
        </div>
    </div>

</div>
</main>
</template>
<script>
import Calendar from "@/components/Calendar/Calendar.vue";
import loadingSpinnerBar from "@/components/LoadingSpinnerBar.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState, mapActions } from "vuex";
import { myCalendarService,lenguagesService,regionsService,clientsService } from "@/_services";
import i18n from '@/_helpers/i18n';
import Modal from "@/components/Common/Modal.vue";



export default {
	data() {
		return {
      urlInvalid: false,
			timezone:160,
			creatingEvent:false,
			newevent:false,
			dayselected:[],
			timezones:[],
			daylabel:false,
			openform:false,
			loadingfirst:true,
			availabilityRequestId: 0,
			name:String,
			avatar:String,
			account_id: String,
			calendar: Object,
			currentmonth:1,
			fixedmonth:1,
			monthlabel:'',
			calkey:12232,
			loading:true,
			theyear:2023,
			fixedyear:2023,
			calendar : {
	    		'title' : '30 Minute Meeting',
	    		'duration':'30 min',
	    		'currentmonth': '',
	    		'labelmonth': '',
	    		'labeldays':['mon','tue','wed','thu','fri','sat','sun'],
	    		'days':[],
				'hours':[],
				'name': "",
				'accountId': false,
				'currentmonth': false,
				'currentyear': false,
				'defaultTimezone' : false,
				'timezonelabel': "Europe/Paris"
	    	},
	    	calendarDefault: {
	    		"availability":[0,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,2,1,1,0,0,0,0,0,0,0,0,0,0,0],
	    		"avatar":null,
	    		"name":"",
	    		"calendar_description":"",
	    		"duration_minutes":"",
	    		"interval_minutes":0
	    	}
		}
	},
	components: {
		Calendar,
		Modal,
		loadingSpinnerBar,
		LoadingSpinner,
	},
	async created() {
	this.getCalendarParam();

	if (typeof this.$route.params.account_id !== "undefined") {
		const accountValue = this.$route.params.account_id;

		if (this.isBase64(accountValue)) {
		const value = atob(accountValue);
		const isUserCalendarValid = await this.userCalendarAvailable(accountValue);

		if (!isNaN(value) && isUserCalendarValid) {
			this.account_id = accountValue;

			const d = new Date();
			this.currentmonth = d.getMonth() + 1;
			this.theyear = d.getFullYear();
			this.fixedyear = d.getFullYear();
			this.fixedmonth = d.getMonth() + 1;

			const month = [
			"january",
			"frebruary",
			"march",
			"april",
			"may",
			"june",
			"july",
			"august",
			"september",
			"october",
			"november",
			"december",
			];
			this.monthlabel = month[this.currentmonth - 1];

			// ✅ Usa los datos del store en lugar de llamar al servicio
			if (this.Languages.length > 0) {
			this.languages = this.Languages;
			} else {
			// fallback (solo si no está cargado en el store)
			await this.$store.dispatch("getLanguages");
			this.languages = this.Languages;
			}

			if (this.TimeZone.length > 0) {
			this.timezones = this.TimeZone;
			} else {
			// fallback
			await this.$store.dispatch("getTimezones");
			this.timezones = this.TimeZone;
			}

			// ✅ Detecta y asigna zona horaria local
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (tz) {
			this.selectTimeZoneLabel(tz, false);
			}

			// ✅ Idioma por defecto y carga inicial
			i18n.locale = "en_US";
			this.loadCalendarField();
			this.loadCalendar(this.calendarDefault);

			// ✅ Configura idioma del usuario
			const res = await myCalendarService.getLanguageId(this.account_id);
			const language_id = res.language_id;

			this.languages.forEach((item) => {
			if (item.id === language_id) {
				i18n.locale = item.lang_code;
			}
			});

			this.nextMonth(this.currentmonth);
			this.$modal.show("loading");
		} else {
			this.urlInvalid = true;
		}
		} else {
		this.urlInvalid = true;
		}

		if (
		typeof this.$route.params.business_contact_hash !== "undefined" &&
		typeof this.$route.params.campaign_hash !== "undefined"
		) {
		myCalendarService.insertActivity(
			this.$route.params.campaign_hash,
			this.$route.params.business_contact_hash,
			true,
			window.location.href
		);
		}
	}
	},
	computed: {
		...mapState({
			headerTab: state => state.header.tab,
      currentUser: (state) => state.authentication.user,
			isMenuCollapse: state => state.sidebar.isNavOpen,
	    completeLoadingCalendar: (state) => state.optionsList.completeLoadingCalendar,
	Languages: (state) => state.optionsList.all["languages"].data,
      TimeZone: (state) => state.optionsList.all["timezones"].data,
		}),

	},
	methods: {
		...mapActions("header", {
		changeHeaderTab: "changeTab"
		}),
		...mapActions("headertopbar", {
			setCurrentRoute:"setRoute",
			setCurrentRouteChild:"setRouteChild",
		}),
	    ...mapActions("optionsList", {
			getCalendarParam: "getCalendarParam",
	    }),
	    createEvent(data){
	    	this.creatingEvent = true
		    myCalendarService.createEventInCalendar(data).then((res) => {
		    	this.creatingEvent = false
		    }).catch(() => {
		    	this.newevent = false
		    	this.creatingEvent = false
		    	this.back()
		    	this.$swal({
		    		type: "error",
		    		text: this.$t("lang.calendar.booking_error"),
		    	});
		    });
	    },
	    loadCalendarField(){
		    this.calendar = {
		    		'title' : '30 Minute Meeting',
		    		'duration':'30 min',
		    		'currentmonth': this.monthlabel,
		    		'labelmonth': this.$t('lang.label.' + this.monthlabel ),
		    		'labeldays':['mon','tue','wed','thu','fri','sat','sun'],
		    		'days':[],
					'hours':[],
					'name': "",
					'accountId':this.account_id,
					'currentmonth':this.currentmonth,
					'currentyear':this.theyear,
					'defaultTimezone' : this.timezone,
					'timezonelabel': "Europe/Paris"
		    };
	    },
	    showDay(day){
	    	this.daylabel=day
	    },
	    selectTimeZone(timezone){
	    	this.timezone = timezone
	    	this.timezones.forEach((item, key)=>{
				if(item.id == this.timezone){
					this.calendar.timezonelabel = item.label
					this.calendar.defaultTimezone = item.id
					this.calendar.timezone = item.id
					return false;
				}
			})
	    	this.nextMonth(this.currentmonth)
	    },
	    selectTimeZoneLabel(label, reload = true){
	    	this.calendar.timezonelabel=label
		    	this.timezones.forEach((item, key)=>{
					if(item.label.indexOf(this.calendar.timezonelabel) !== -1) {
						this.calendar.timezonelabel = item.label
						this.calendar.defaultTimezone = item.id
						this.timezone = item.id
						return;
					}
				})
				if (reload) {
					this.nextMonth(this.currentmonth)
				}
	            return;

	    },
		eventCreated(model){
			this.newevent = model
		},
		openForm(dayselected){
			this.dayselected = dayselected
			this.openform=true
		},
		back(){
			this.dayselected=[]
			this.openform=false
			this.calkey++
		},
		nextMonth(currentmonth){
			if(currentmonth == 13){
				currentmonth = 1
				this.theyear++
			}
			if(currentmonth == 0){
				currentmonth = 12
				this.theyear--
			}
			this.currentmonth = currentmonth
			let month = ["january","frebruary","march","april","may","june","july","august","september","october","november","december"];
			this.monthlabel = month[currentmonth-1]
			this.getAvailabilityByMonth(currentmonth,this.theyear,this.account_id)
		},
		udpdateHeader(route){
			this.setCurrentRoute({page:route});
		},

		getAvailabilityByMonth(month,theyear,account_id){
			const requestId = ++this.availabilityRequestId
			this.loading = true
			this.calendar.currentmonth = month
			this.calendar.currentyear = theyear
			myCalendarService.getAvailabilityByMonth(month,theyear,account_id,this.timezone).then((res) => {
				if (requestId !== this.availabilityRequestId) return
				if(res){
					this.loadCalendar(res)
					this.loading = false
					this.loadingfirst = false
				}else{
				}
			})
			if(this.currentUser){
				myCalendarService.getEventsByMonth(month,theyear,account_id).then((res) => {
					
				})
			}

		},
		loadCalendar(res){
			this.calendar.days=[]
			this.avatar = res.avatar
			this.name = res.name
			this.calendar.name = res.name
			this.calendar.calendar_description = res.calendar_description
			this.calendar.duration = res.duration_minutes+' min'
			this.calendar.title = res.duration_minutes+' Minute Meeting'
			res.availability.forEach((item, key)=>{
				this.calendar.days.push(item)
			})

			if(this.calendar.days.length == res.availability.length){
				this.calkey++
				this.loading = false
			}
		},
    isBase64(value) {
      // Revisar si la cadena solo contiene caracteres válidos
      if (/^[a-zA-Z0-9+/]*={0,2}$/.test(value)) {
          // Revisar si la longitud de la cadena es un múltiplo de 4
          if (value.length % 2 === 0) {
              return true;
          }
      }
    return false;
    },
    async userCalendarAvailable(account_id){
      try {
        const res = await myCalendarService.userCalendarAvailable(account_id)
        return res ? res : false
      } catch (error) {
        console.log(error)
        return false
      }
 	   }
  }

 }
</script>
<style>
	.blur{
	    filter: blur(5px);
	}
</style>
